module.exports = __webpack_public_path__ + "media/my_images/vision/hukidasi-5f54b49be1a3e70e4658b1bec8a403b6.png";